import { GeoPoint } from "firebase/firestore";
import { SortingRules } from "../constants/trash";
import { Coordinates } from "../helpers/geo";

export enum PartnerStatus {
    /** Partner is currently active and recording data. */
    ACTIVE = "active",
    /** Partner is not recording data anymore. */
    INACTIVE = "inactive",
    /** Partner doesn't have a contract with Ficha anymore and has been archived. */
    ARCHIVED = "archived",
    /** Demonstration account. */
    DEMO = "demo",
}

export type PartnerDbData = {
    /** Preferred viewport for the maps to focus on before any points are loaded. */
    defaultMapViewport?: {
        center: GeoPoint;
        zoom: number;
    };
    /** URL to the partner's logo media file, relative to the root of the bucket. */
    logoURL: string;
    /** Displayable name of the Partner. */
    name: string; 
    /** Status of the contract with the Partner (active, archived, demo...). */
    status: PartnerStatus;
    /** 
     * Indicate which collection different wastes belong to 
     * (other than default values, see DEFAULT_SORTING_ERRORS).
     * @example 
     * ```
     * {
     *   "polystyrene": ["sortable_waste"],
     *   "bigCardboard": ["landfill", "big_cardboard"]
     * }
     * ```
     * indicate that for this partner, polystyrene is not an error is sortable waste collection,
     * wherease big cardboards are, since they have a dedicated collection or should be brought to landfill. 
     */
    sortingRules?: Partial<SortingRules>;
}

type Partner = Omit<PartnerDbData, "defaultMapViewport"> & {
    ID: string;
    /** Preferred viewport for the maps to focus on before any points are loaded. */
    defaultMapViewport?: {
        center: Coordinates;
        zoom: number;
    };
}

export default Partner;